//import '../../node_modules/@fortawesome/fontawesome-free/css/all.css';


import "../styles/app.scss";
import 'bootstrap';
require('bootstrap');

// Perso
import {Website} from './inc/website.js';
import {ProjectsFilter} from './inc/projects.js';


new Website()
new ProjectsFilter()

